// Copyright 2018-2024 the Deno authors. All rights reserved. MIT license.

import type { Comparator, SemVer } from "./types.ts";

/**
 * The minimum valid SemVer object. Equivalent to `0.0.0`.
 */
export const MIN: SemVer = {
  major: 0,
  minor: 0,
  patch: 0,
  prerelease: [],
  build: [],
};

/**
 * ANY is a sentinel value used by some range calculations. It is not a valid
 * SemVer object and should not be used directly.
 */
export const ANY: SemVer = {
  major: Number.NaN,
  minor: Number.NaN,
  patch: Number.NaN,
  prerelease: [],
  build: [],
};

/**
 * A comparator which will span all valid semantic versions
 */
export const ALL: Comparator = {
  operator: undefined,
  ...ANY,
};

export const OPERATORS = [
  undefined,
  "=",
  "!=",
  ">",
  ">=",
  "<",
  "<=",
] as const;

// denoCacheMetadata={"headers":{"content-type":"text/typescript","content-security-policy":"default-src 'none'; script-src 'none'; style-src 'none'; img-src 'none'; font-src 'none'; connect-src 'none'; frame-src 'none'; object-src 'none'; frame-ancestors 'none'; sandbox; form-action 'none';","cross-origin-resource-policy":"cross-origin","alt-svc":"h3=\":443\"; ma=2592000,h3-29=\":443\"; ma=2592000","x-goog-metageneration":"1","access-control-allow-origin":"*","last-modified":"Wed, 04 Sep 2024 10:41:42 GMT","etag":"\"11a0f79f6e6c81d85cf137602145b3e3\"","x-goog-stored-content-length":"796","x-jsr-cache-id":"IAD","x-goog-generation":"1725446501973180","accept-ranges":"bytes","cache-control":"public, max-age=31536000, immutable","x-jsr-cache-status":"hit","x-goog-stored-content-encoding":"identity","x-content-type-options":"nosniff","x-goog-storage-class":"STANDARD","x-goog-hash":"crc32c=y9uXow==,md5=EaD3n25sgdhc8TdgIUWz4w==","x-guploader-uploadid":"AHmUCY1CsktOQxMNMzJNNqZ34vc4Miw04seIA3_EhKqUoi2Hc-ABwDRhfPP3t2JQ5GFsfxvVC9Q","server":"UploadServer","date":"Fri, 08 Nov 2024 09:36:15 GMT","content-length":"796","via":"1.1 google","age":"2026","x-robots-tag":"noindex","access-control-expose-headers":"*","expires":"Sat, 08 Nov 2025 09:36:15 GMT"},"url":"https://jsr.io/@std/semver/1.0.3/_constants.ts","time":1731060601}